import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// import sessionStorage from "redux-persist/es/storage/session";

import userSlice from "./reducers/userInfo";
import LiveShoppingFormSlice from "./reducers/LiveShoppingFormSlice";
import ShopifyProduct from "./reducers/ShopifyProduct";

import VideoStorage from "./reducers/VideoStorage";
import ChatSlice from "./reducers/ChatSlice";
import StaffSlice from "./reducers/StaffSlice";
import staffInfoSlice from "./reducers/staffInfoSlice";
import storeSlice from "./reducers/StoreSlice";

const persistUserConfig = { key: 'root_user', version: 1, storage: storage, blacklist: ['showLoader'] }
const persistStaffConfig = { key: 'root_staff', version: 1, storage: storage, blacklist: ['showLoader'] }

const persistedUser = persistReducer(persistUserConfig, userSlice)
const persistedStaff = persistReducer(persistStaffConfig, staffInfoSlice)

let rootReducers = combineReducers({
    user_info: persistedUser,
    ShopifyProduct: ShopifyProduct,
    liveShoppingForm: LiveShoppingFormSlice,
    VideoStorage_info: VideoStorage,
    chat: ChatSlice,
    staff: StaffSlice,
    staffInfo: persistedStaff,
    storeInfo: storeSlice
})

export const store = configureStore({
    reducer: rootReducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }),
})

const persistor = persistStore(store)
export default persistor;